/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiWebhooksGet } from '../fn/webhooks/api-webhooks-get';
import { ApiWebhooksGet$Params } from '../fn/webhooks/api-webhooks-get';
import { apiWebhooksIdDelete } from '../fn/webhooks/api-webhooks-id-delete';
import { ApiWebhooksIdDelete$Params } from '../fn/webhooks/api-webhooks-id-delete';
import { apiWebhooksIdGet } from '../fn/webhooks/api-webhooks-id-get';
import { ApiWebhooksIdGet$Params } from '../fn/webhooks/api-webhooks-id-get';
import { apiWebhooksPost } from '../fn/webhooks/api-webhooks-post';
import { ApiWebhooksPost$Params } from '../fn/webhooks/api-webhooks-post';
import { apiWebhooksRequestsIdGet } from '../fn/webhooks/api-webhooks-requests-id-get';
import { ApiWebhooksRequestsIdGet$Params } from '../fn/webhooks/api-webhooks-requests-id-get';
import { apiWebhooksWebhookIdRequestsGet } from '../fn/webhooks/api-webhooks-webhook-id-requests-get';
import { ApiWebhooksWebhookIdRequestsGet$Params } from '../fn/webhooks/api-webhooks-webhook-id-requests-get';
import { CreateResult } from '../models/create-result';
import { GetWebhookRequestsResult } from '../models/get-webhook-requests-result';
import { WebhookDto } from '../models/webhook-dto';
import { WebhookRequestDetailDto } from '../models/webhook-request-detail-dto';


/**
 * Webhook management
 */
@Injectable({ providedIn: 'root' })
export class WebhooksService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiWebhooksGet()` */
  static readonly ApiWebhooksGetPath = '/api/Webhooks';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebhooksGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebhooksGet$Response(params?: ApiWebhooksGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WebhookDto>>> {
    const obs = apiWebhooksGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebhooksGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebhooksGet(params?: ApiWebhooksGet$Params, context?: HttpContext): Observable<Array<WebhookDto>> {
    const resp = this.apiWebhooksGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WebhookDto>>): Array<WebhookDto> => r.body)
    );
  }

  /** Path part for operation `apiWebhooksPost()` */
  static readonly ApiWebhooksPostPath = '/api/Webhooks';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebhooksPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWebhooksPost$Response(params?: ApiWebhooksPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateResult>> {
    const obs = apiWebhooksPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebhooksPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWebhooksPost(params?: ApiWebhooksPost$Params, context?: HttpContext): Observable<CreateResult> {
    const resp = this.apiWebhooksPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CreateResult>): CreateResult => r.body)
    );
  }

  /** Path part for operation `apiWebhooksIdGet()` */
  static readonly ApiWebhooksIdGetPath = '/api/Webhooks/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebhooksIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebhooksIdGet$Response(params: ApiWebhooksIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<WebhookDto>> {
    const obs = apiWebhooksIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebhooksIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebhooksIdGet(params: ApiWebhooksIdGet$Params, context?: HttpContext): Observable<WebhookDto> {
    const resp = this.apiWebhooksIdGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<WebhookDto>): WebhookDto => r.body)
    );
  }

  /** Path part for operation `apiWebhooksIdDelete()` */
  static readonly ApiWebhooksIdDeletePath = '/api/Webhooks/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebhooksIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebhooksIdDelete$Response(params: ApiWebhooksIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiWebhooksIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebhooksIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebhooksIdDelete(params: ApiWebhooksIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiWebhooksIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebhooksWebhookIdRequestsGet()` */
  static readonly ApiWebhooksWebhookIdRequestsGetPath = '/api/Webhooks/{webhookId}/requests';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebhooksWebhookIdRequestsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebhooksWebhookIdRequestsGet$Response(params: ApiWebhooksWebhookIdRequestsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetWebhookRequestsResult>> {
    const obs = apiWebhooksWebhookIdRequestsGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebhooksWebhookIdRequestsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebhooksWebhookIdRequestsGet(params: ApiWebhooksWebhookIdRequestsGet$Params, context?: HttpContext): Observable<GetWebhookRequestsResult> {
    const resp = this.apiWebhooksWebhookIdRequestsGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetWebhookRequestsResult>): GetWebhookRequestsResult => r.body)
    );
  }

  /** Path part for operation `apiWebhooksRequestsIdGet()` */
  static readonly ApiWebhooksRequestsIdGetPath = '/api/Webhooks/requests/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWebhooksRequestsIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebhooksRequestsIdGet$Response(params: ApiWebhooksRequestsIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<WebhookRequestDetailDto>> {
    const obs = apiWebhooksRequestsIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWebhooksRequestsIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWebhooksRequestsIdGet(params: ApiWebhooksRequestsIdGet$Params, context?: HttpContext): Observable<WebhookRequestDetailDto> {
    const resp = this.apiWebhooksRequestsIdGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<WebhookRequestDetailDto>): WebhookRequestDetailDto => r.body)
    );
  }

}
